import { Fragment, useEffect } from "react";
import "react-tooltip/dist/react-tooltip.css";
import { Tab } from "@headlessui/react";
import TabList from "../../common/TabList";
import ChartNav from "../../common/ChartNav";
import PersonalInformation from "./components/PersonalInformation";
import ContactInformation from "./components/ContactInformation";
import InsuranceInformation from "./components/InsuranceInformation";
import CaregiverInformation from "./components/CaregiverInformation";
import PhysicianInformation from "./components/PhysicianInformation";
import SubNavigation from "../clinical-services/common/sub-navigation";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/solid";
import { useParams } from "react-router-dom";
import { fetchNotepad } from "../../../redux/modules/patient/actions";
import ComingSoon from '../../ComingSoon'


const PatientDetail = () => {
  const patientDetailTabs = [
    { name: "Personal", disabled: false },
    { name: "Insurance", disabled: false },
    { name: "Alternate Caregiver", disabled: false },
    { name: "Primary Provider", disabled: false },
    { name: "Referrals", disabled: true },
    { name: "Appointments", disabled: true },
    { name: "Activity Log", disabled: false },
  ];
  const { id } = useParams();
  const dispatch = useDispatch();
  const { patient } = useSelector((state) => state.patients);
  const { medicalConditions: condition } = useSelector(
    (state) => state.clinicalService
  );
  const { medicalConditions } = condition;
  const [showMenu, setShowMenu] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(0);

  useEffect(() => {
    dispatch(fetchNotepad(id));
  }, [dispatch]);

  const selectAlternateCaregiver = () => {
    const alternateCaregiverIndex = patientDetailTabs.findIndex(
      (val) => val.name === "Alternate Caregiver"
    );
    setSelectedIndex(alternateCaregiverIndex);
  };

  if (!patient) return null;
  return (
    <div className="relative flex flex-col flex-1 w-full gap-4 pt-5 bg-white">
      {/* <div className="flex flex-col"> */}
      <Tab.Group>
        <Tab.Panels as={Fragment}>
          <Tab.Panel as={Fragment}>
            <Tab.Group
              selectedIndex={selectedIndex}
              onChange={setSelectedIndex}
            >
              <div className="flex flex-1 overflow-hidden gap-9">
                <div
                  className={`flex gap-5 relative ${
                    showMenu ? "min-w-[320px] 2xl:min-w-[400px]" : ""
                  }`}
                >
                  <ChartNav />
                  {/* {!showMenu && (
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMenu(!showMenu);
                      }}
                      className={`${
                        showMenu ? "" : "absolute"
                      } flex items-center justify-center w-6 h-6 mt-2 mr-2 -ml-2 transform bg-teal-600 left-full rounded-3xl`}
                    >
                      <img
                        src="/icons/angle-left.svg"
                        alt="back"
                        className="block -mr-0.5 transform rotate-180 filter invert "
                      />
                    </button>
                  )} */}
                  {showMenu && (
                    <div className="grid w-[318px]">
                      <div className="flex flex-col flex-1 pt-2">
                        <div className="relative mb-4">
                          <h5 className="text-xl font-bold text-teal-300">
                            Patient Details
                          </h5>
                        </div>
                        <TabList listItems={patientDetailTabs} />
                      </div>
                    </div>
                  )}
                  <div
                    className={`relative w-[7px] transition bg-gray-100 group`}
                  >
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        setShowMenu(!showMenu);
                      }}
                      className={`absolute flex items-center justify-center w-6 h-6 m-auto bg-teal-300 top-64 -right-2 rounded-3xl opacity-100 cursor-pointer `}
                    >
                      {showMenu ? (
                        <ChevronLeftIcon className="w-5 h-5 text-white -ml-0.5" />
                      ) : (
                        <ChevronRightIcon className="w-5 h-5 text-white ml-0.5" />
                      )}
                    </button>
                  </div>
                </div>
                <div
                  className={`flex flex-1 pt-12 relative ${
                    showMenu
                      ? "max-w-[calc(100%-335px)] 2xl:max-w-[calc(100%-436px)]"
                      : "border-r-4 border-gray-20"
                  }`}
                >
                  <div className="absolute right-2 top-2 z-10">
                    <SubNavigation />
                  </div>
                  <Tab.Panels as={Fragment}>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Personal
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-2 overflow-x-auto">
                          <PersonalInformation
                            patient={patient}
                            conditions={medicalConditions}
                          />

                          <ContactInformation
                            patient={patient}
                            navigateToAlternateCaregiver={
                              selectAlternateCaregiver
                            }
                          />
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Insurance
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full">
                            <InsuranceInformation patient={patient} />
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Caregiver Information
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-4">
                          <div className="flex-1">
                            <CaregiverInformation patient={patient} />
                          </div>
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Primary Provider
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-4">
                          <div className="flex-1">
                            <PhysicianInformation patient={patient} />
                          </div>
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Referrals
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-4">
                          <ComingSoon />
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Appointments
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-4">
                          <ComingSoon />
                        </div>
                      </div>
                    </Tab.Panel>
                    <Tab.Panel as={Fragment}>
                      <div className="flex flex-col w-full gap-4 -mt-12">
                        <div className="w-full">
                          <div className="flex items-center justify-between mt-2.5 mb-0.5">
                            <h4 className="font-bold text-teal-300 text-xs-display">
                              Activity Log
                            </h4>
                          </div>
                          <div className="border-b-[7px] border-gray-20 mb-[20px]"></div>
                        </div>
                        <div className="flex flex-row w-full gap-4">
                          <ComingSoon />
                        </div>
                      </div>
                    </Tab.Panel>
                  </Tab.Panels>
                </div>
              </div>
            </Tab.Group>
          </Tab.Panel>
        </Tab.Panels>
      </Tab.Group>
      {/* </div> */}
    </div>
  );
};

export default PatientDetail;
